<template>
	<v-card rounded="xl" elevation="2">
		<v-card-title class="text-primary">
			{{ title }}
		</v-card-title>

		<v-card-text>
			<v-select
				v-model="productModel.productMake"
				:items="productMakes"
				label="Marque de Produit"
				:rules="[(value) => !!value || 'Required']"
			/>

			<v-text-field
				v-model="productModel.model"
				label="Modèle"
				:rules="[(value) => !!value || 'Required']"
			/>
		</v-card-text>

		<v-card-actions class="justify-space-between">
			<v-btn variant="text" @click="goBack">
				Retour
			</v-btn>

			<v-btn color="primary" :loading="loading" @click="submit">
				Sauvegarder
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore } from '@/store'
import { ProductMake } from '@/types'
import type { ProductModel } from '@/types/product-model'
import { fetchProductModelById, postProductModel, putProductModel } from '@/utils/product-model-api'

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()

const loading = ref(false)
const productModel = ref<ProductModel>({
	productMake: null as any,
	model: ''
})

const productMakes = Object.values(ProductMake)

const isCreatingNewModel = computed(() => route.params.id === 'new')
const title = computed(() => isCreatingNewModel.value ? 'Nouveau Modèle' : 'Éditer Modèle')

function goBack() {
	router.push({ name: 'productmodels' })
}

async function submit() {
	try {
		loading.value = true
		const modelData = { ...productModel.value }

		if (!modelData.id) {
			productModel.value = await postProductModel(modelData)
			appStore.sendSuccessNotice('Nouveau modèle créé.')
			router.replace({
				name: 'ProductModelEditor',
				params: { id: productModel.value.id }
			})
		} else {
			await putProductModel(modelData)
			appStore.sendSuccessNotice('Modèle mis à jour.')
		}
	} catch (e) {
		// Ignore because it's handled in axios service
	} finally {
		loading.value = false
	}
}

onMounted(async () => {
	try {
		loading.value = true
		if (isCreatingNewModel.value) {
			productModel.value = {
				productMake: null as any,
				model: ''
			}
			return
		}

		const modelId = route.params.id as string
		productModel.value = await fetchProductModelById(modelId)
	} catch (e) {
		// Ignore because it's handled in axios service
	} finally {
		loading.value = false
	}
})
</script>
